// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ey-a";
export var fulfillmentFormRail = "_ey-9";
export var headerTitleRow = "_ey-c";
export var orderDetailsWrapper = "_ey-7";
export var orderLinkTrigger = "_ey-2";
export var paymentInformationGrid = "_ey-h";
export var paymentSummaryColumn = "_ey-i";
export var shipmentContainer = "_ey-b";
export var shipmentDetailsMainPane = "_ey-8";
export var shipmentNavigationCard = "_ey-5";
export var shipmentNavigationRail = "_ey-3";
export var shipmentNavigationRailHeader = "_ey-4";
export var shipmentSummaryFact = "_ey-e";
export var shipmentSummaryGrid = "_ey-d";
export var shipmentSummaryMetadataRow = "_ey-f";
export var shipmentSummaryTags = "_ey-g";
export var shipmentWorkspace = "_ey-0";
export var shipmentWorkspaceContent = "_ey-6";
export var shipmentWorkspaceHeader = "_ey-1";